<template>
    <v-card tile flat :class="little ? 'goal-background' : 'theme-background'">
        <v-container v-if="!little" class="goal-container pl-4 pr-4 pb-4" :style="{'border-color': $vuetify.theme.dark ? '#ffffff' : '#000000'}">
            <v-layout class="goal-text theme-title" row>Kapu</v-layout>
            <v-layout v-for="i in 3" :key="i" class="goal-row" :class="i === 3 ? 'goal-row-border-helper' : ''">
                <v-flex v-for="j in 3" :key="j" class="goal-tile" md4 @mouseover="mouseOver(((i-1)*3 + j))" @mouseleave="mouseLeave" @click="placeBall(((i-1)*3 + j))">
                    <v-icon class="soccer-ball" :class="( selectedPosition === ((i-1)*3 + j) ) ? 'goal-area-selected' : ''" v-show="(soccerBallPosition === ((i-1)*3 + j) || selectedPosition === ((i-1)*3 + j) )">mdi-soccer</v-icon>
                </v-flex>
            </v-layout>
        </v-container>
        <v-card tile flat v-if="little" class="size-little transparent">
            <v-layout v-for="i in 3" :key="i" class="goal-row" :class="i === 3 ? 'goal-row-border-helper' : ''">
                <v-flex v-for="j in 3" :key="j" class="goal-tile little" md4>
                    <v-icon class="soccer-ball" :class="( selectedPosition === ((i-1)*3 + j) ) ? 'goal-area-selected' : ''"></v-icon>
                </v-flex>
            </v-layout>
        </v-card>
    </v-card>
</template>

<script>
    import eventBus from '@/eventBus';
    import CONSTANTS from '@/constants';

    import busListeners from "@/mixins/busListeners";

export default {
    mixins: [busListeners],
        name: "Goal",
        props: {
            little: Boolean,
        },
        data() {
          return {
              soccerBallPosition: 0,
              selectedPosition: 0,
              isBallPlaced: false
          }
        },
        methods: {
            mouseOver: function(position) {
                this.soccerBallPosition = position;
            },
            mouseLeave: function() {
                this.soccerBallPosition = 0;
            },
            placeBall: function(position) {
                if(!this.little) {
                    if(this.selectedPosition === position) {
                        this.selectedPosition = 0;
                        this.isBallPlaced = false;
                        eventBus.$emit(CONSTANTS.ACTIONS.BALLPLACED, false);
                    }
                    else {
                        this.selectedPosition = position;
                        let nullPosition = (!position || position === 0 || position === undefined);
                        this.isBallPlaced = !nullPosition;
                        eventBus.$emit(CONSTANTS.ACTIONS.BALLPLACED, !nullPosition);
                    }
                }
            }
        },
        watch: {
            selectedPosition: function() {
                if (!this.little) {
                    eventBus.$emit(CONSTANTS.ACTIONS.SELECTED.GATE, this.selectedPosition);
                }
            }
        },
        created: function () {
            let self = this;
            this.$busOn(CONSTANTS.ACTIONS.SELECTED.GATE, function(position) {
                self.selectedPosition = position;
            });
            this.$busOn(CONSTANTS.EVENTS.RECORD.CREATED, function () {
                self.selectedPosition = 0;
            });
            this.$busOn(CONSTANTS.ACTIONS.RESTORE.SELECTION, function (record) {
                if(record) {
                    self.placeBall(record.selectedGateArea);
                }
            });
        }
    }
</script>

<style scoped>
    .goal-container {
        border-width: 1px;
        border-style: solid;
        border-radius: 0 !important;
        width: 158px;
        position: relative;
    }

    .goal-row {
        min-height: 41px;
        width: 124px;
        border-top-width: 1px;
        border-right-width: 1px;
        border-left-width: 0;
        border-bottom-width: 0;
        border-style: solid;
    }

    .goal-tile {
        display: grid;
        vertical-align: middle;
        border-left-width: 1px;
        border-top-width: 0;
        border-right-width: 0;
        border-bottom-width: 0;
        border-style: solid;
    }

    .goal-row-border-helper {
        border-bottom-width: 1px;
        border-style: solid;
    }

    .theme--light.goal-row, .theme--light.goal-tile, .theme--light.goal-row-border-helper {
        border-color: #000000 !important;
    }

    .theme--dark.goal-row, .theme--dark.goal-tile, .theme--dark.goal-row-border-helper {
        border-color: #ffffff !important;
    }

    .theme--light.goal-background {
        background-color: #ffffff !important;
    }

    .theme--dark.goal-background {
        background-color: #6a6d77 !important;
    }

    .goal-area-selected, .goal-tile:not(.little):hover {
        background-color: #23C373;
        cursor: pointer;
    }

    .goal-text {
        font-size: 11px;
        font-stretch: condensed;
        font-family: 'Roboto Condensed';
        text-align: center;
        margin-bottom: 10px;
        display: block;
        line-height: 19px;
    }

    .soccer-ball {
        color: #ffffff !important;
    }

    .mdi:before, .mdi-set {
        font-size: 32px;
    }

    .size-little .goal-row {
        min-height: 12px;
        width: 34px;
    }

    .size-little .mdi:before {
        font-size: 10px;
    }
</style>
